"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarrilQueryProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const query_client_1 = require("./query.client");
const query_context_1 = require("./query.context");
function BarrilQueryProvider({ children, client = query_client_1.barrilQueryClient, }) {
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, Object.assign({ client: client, context: query_context_1.BarrilQueryClientContext }, { children: children })));
}
exports.BarrilQueryProvider = BarrilQueryProvider;
